import { Platform, ScrollView, StyleSheet } from 'react-native';
import React, { useContext } from 'react';
import type { NativeStackScreenProps } from '@react-navigation/native-stack';
import { SOTFlowType } from '../types';
import { Text, View } from '../components/Themed';
import ButtonStandard from '../components/buttons/ButtonStandard';
import NavHeader from '../components/LayoutSections/NavHeader';
import { globalStyles } from '../Global/GlobalStyles';
import { environment } from '../environments/environment';
import { SoTContext } from '../Global/SoTContext';
import firebase from '../Global/firebase';
import { SOT_CREATE_ACCOUNT } from '../constants/Events';

type Props = NativeStackScreenProps<SOTFlowType>;
export default function WhatsNextScreen({ navigation }: Props) {
  const { user } = useContext(SoTContext);
  console.log('WhatsNextScreen');
  const Bold = ({ children }: any) => (
    <Text style={{ fontWeight: '800', color: '#6C7570' }}>{children}</Text>
  );

  return (
    <View style={styles.container}>
      <NavHeader
        isIntroPage={false}
        backButtonNavigation="SplashScreen"
        props={navigation}
        style={{ marginBottom: 30 }}
        steps={[]}
        width={globalStyles.container.width}
        height="112px"
      ></NavHeader>
      <ScrollView style={{ flex: 1, paddingHorizontal: 20 }}>
        <Text style={styles.title}>What's next?</Text>
        {/* <View style={styles.separatorClear} lightColor="#eee" darkColor="rgba(255,255,255,0.1)" /> */}
        <Text style={styles.subTitle}>
          No one sees {user.first} quite like you do. What you share builds trust – and that’s how
          we help {user?.gender.toLowerCase() === 'male' ? 'him' : 'her'} find real compatibility.
        </Text>
        {/* <Text style={styles.subTitle}>
          Our <Bold>Sphere of Trust</Bold> lets you share what makes {user.first} special. This helps us match {user.first} with singles who appreciate {user?.gender.toLowerCase() === 'male' ? 'him' : 'her'} for who {user?.gender.toLowerCase() === 'male' ? 'he' : 'she'} is.
        </Text> */}
        <View style={[styles.miniSection]}>
          <View style={styles.miniSectionLeft}>
            <svg
              width="62"
              height="62"
              viewBox="0 0 72 72"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M54.1397 35.2102L54.1654 35.228L54.1966 35.2281C63.9571 35.256 71.9 43.2129 71.9 52.9874C71.9 62.776 63.9291 70.7468 54.1406 70.7468H10.2234C4.62693 70.7468 0.1 66.7578 0.1 61.875V48.8671C0.1 43.6977 2.41775 39.198 6.8389 35.8122C9.82074 33.5303 13.7306 31.7775 18.2905 30.6831L18.4587 30.6428L18.3398 30.5172C15.3893 27.3988 13.5719 23.2044 13.5719 18.5906C13.5719 9.02705 21.3459 1.25308 30.9094 1.25308C40.4729 1.25308 48.2469 9.02705 48.2469 18.5906C48.2469 23.2045 46.4294 27.4129 43.4791 30.517L43.3602 30.6421L43.5279 30.683C47.6673 31.6933 51.2834 33.2219 54.1397 35.2102ZM8.92515 38.5643L8.92498 38.5644C5.37352 41.2952 3.55625 44.7545 3.55625 48.8671V61.875C3.55625 64.8738 6.56072 67.2906 10.2234 67.2906H43.3406H43.6355L43.4015 67.1112C39.1498 63.8526 36.3953 58.7344 36.3953 52.9874C36.3953 45.1847 41.4433 38.5422 48.4493 36.165L48.6893 36.0835L48.4584 35.9791C45.9601 34.85 43.0547 34.004 39.8556 33.4685L39.8191 33.4624L39.7875 33.4815C37.1871 35.0473 34.1392 35.9421 30.8953 35.9421C27.6514 35.9421 24.6036 35.0473 22.0031 33.4815L21.9715 33.4624L21.9351 33.4685C16.6086 34.3563 12.1199 36.1188 8.92515 38.5643ZM51.8199 54.816L51.8906 54.8867L51.9613 54.816L60.3004 46.4769C60.9785 45.7988 62.0683 45.7988 62.7465 46.4769C63.4246 47.155 63.4246 48.2449 62.7465 48.923L53.1137 58.5558C52.7948 58.8747 52.3561 59.0609 51.8906 59.0609C51.4388 59.0609 50.9862 58.8744 50.6676 58.5558L45.5488 53.4371C44.8707 52.7589 44.8707 51.6691 45.5488 50.991C46.227 50.3128 47.3168 50.3128 47.9949 50.991L51.8199 54.816ZM54.1406 67.2906C62.0287 67.2906 68.4437 60.8755 68.4437 52.9874C68.4437 45.0994 62.0287 38.6843 54.1406 38.6843C46.2526 38.6843 39.8375 45.0994 39.8375 52.9874C39.8375 60.8755 46.2526 67.2906 54.1406 67.2906ZM44.7766 18.5906C44.7766 10.9417 38.5584 4.70933 30.8953 4.70933C23.2463 4.70933 17.0141 10.9416 17.0141 18.5906C17.0141 26.2396 23.2463 32.4718 30.8953 32.4718C38.5443 32.4718 44.7766 26.2396 44.7766 18.5906Z"
                fill="#093F76"
                stroke="white"
                strokeWidth="0.2"
              />
            </svg>
          </View>
          <View style={[styles.miniSectionRight, { paddingBottom: Platform.OS == 'web' ? 40 : 0 }]}>
            <Text style={styles.miniSectionTitle}>Vouch</Text>
            <Text style={styles.miniSectionText}>
              Confirm the facts and pick the traits that show who {user.first} really is.
            </Text>
          </View>
        </View>

        <View style={styles.separator} />
        <View style={styles.miniSection}>
          <View style={styles.miniSectionLeft}>
            <svg
              width="62"
              height="62"
              viewBox="0 0 72 72"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M63.6007 33.0456L63.6633 33.1014L63.7469 33.0959C63.912 33.0851 64.0767 33.0782 64.242 33.0782H69.8906C70.9453 33.0782 71.8 33.933 71.8 34.9876V46.2843C71.8 47.3389 70.9453 48.1937 69.8906 48.1937H69.7407H69.5407V48.3937V64.3596C69.5407 65.4137 68.6859 66.2689 67.6313 66.2689H4.36871C3.3141 66.2689 2.45934 65.4137 2.45934 64.3596V48.3937V48.1937H2.25934H2.10938C1.05473 48.1937 0.2 47.3389 0.2 46.2843V34.9876C0.2 33.933 1.05473 33.0782 2.10938 33.0782H7.758C7.92331 33.0782 8.08742 33.0851 8.25252 33.0959L8.33618 33.1014L8.39874 33.0456C10.0508 31.5712 11.9344 30.4366 13.9644 29.6779L14.2877 29.5571L14.0222 29.3367C11.1006 26.9114 9.23735 23.2552 9.23735 19.1717C9.23735 11.89 15.1623 5.96563 22.444 5.96563C29.7257 5.96563 35.65 11.89 35.65 19.1717C35.65 22.6709 34.2818 25.8563 32.0521 28.2218L31.7343 28.559H32.1976H42.0623H42.5256L42.2078 28.2218C39.9781 25.8562 38.6093 22.6709 38.6093 19.1717C38.6093 11.89 44.5337 5.96563 51.8159 5.96563C59.0976 5.96563 65.022 11.89 65.022 19.1717C65.022 23.6133 62.8179 27.55 59.4444 29.9461L59.1676 30.1426L59.4737 30.2895C60.9579 31.0014 62.3457 31.9258 63.6007 33.0456ZM67.7812 44.3749H67.9812V44.1749V37.097V36.897H67.7812H64.242C62.1804 36.897 60.5028 38.574 60.5028 40.6357C60.5028 42.6979 62.1804 44.3749 64.242 44.3749H67.7812ZM4.21875 36.897H4.01875V37.097V44.1749V44.3749H4.21875H7.758C9.81958 44.3749 11.4972 42.6979 11.4972 40.6362C11.4972 38.574 9.8196 36.897 7.758 36.897H4.21875ZM6.47809 48.1937H6.27809V48.3937V62.2496V62.4496H6.47809H11.2967H11.4967V62.2496V53.0623C11.4967 52.0082 12.352 51.1529 13.4061 51.1529C14.4607 51.1529 15.3154 52.0082 15.3154 53.0623V62.2502V62.4502H15.5154H33.8906H34.0906V62.2502V46.2843C34.0906 40.8533 36.5465 35.9854 40.407 32.7312L40.8256 32.3783H40.2781H20.1846C17.5162 32.3783 14.9614 33.125 12.76 34.5201H12.2233L12.6389 34.8726C14.275 36.2603 15.316 38.3286 15.316 40.6357C15.316 44.8033 11.9251 48.1937 7.758 48.1937H6.47809ZM65.5219 62.4496H65.7219V62.2496V48.3937V48.1937H65.5219H64.2426C60.0749 48.1937 56.6846 44.8033 56.6846 40.6362C56.6846 38.3382 57.7159 36.2785 59.3402 34.8903L59.5446 34.7155L59.3185 34.57C57.1003 33.1429 54.5166 32.3783 51.8159 32.3783C44.1474 32.3783 37.9094 38.6163 37.9094 46.2843V62.2496V62.4496H38.1094H56.484H56.684V62.2496V53.0623C56.684 52.0082 57.5393 51.1529 58.5934 51.1529C59.648 51.1529 60.5028 52.0082 60.5028 53.0623V62.2496V62.4496H60.7028H65.5219ZM51.8154 9.78438C46.6391 9.78438 42.4281 13.9954 42.4281 19.1717C42.4281 24.3485 46.6391 28.559 51.8159 28.559C56.9922 28.559 61.2032 24.3485 61.2032 19.1717C61.2032 13.9954 56.9916 9.78438 51.8154 9.78438ZM31.8313 19.1717C31.8313 13.9954 27.6202 9.78438 22.444 9.78438C17.2672 9.78438 13.0561 13.9954 13.0561 19.1717C13.0561 24.3485 17.2672 28.559 22.444 28.559C27.6202 28.559 31.8313 24.3479 31.8313 19.1717Z"
                fill="#093F76"
                stroke="white"
                strokeWidth="0.4"
              />
            </svg>
          </View>
          <View style={styles.miniSectionRight}>
            <Text style={styles.miniSectionTitle}>Share Your Perspective</Text>
            <Text style={styles.miniSectionText}>
              Describe {user.first} in your own words – the moments only you would know.
            </Text>
          </View>
        </View>
      </ScrollView>
      <View
        style={{
          width: '100%',
          position: 'absolute',
          bottom: globalStyles.container.height < 800 ? 10 : 20,
          paddingHorizontal: 20,
          backgroundColor: 'transparent',
        }}
      >
        <ButtonStandard
          label="Next"
          onPress={() => {
            const analytics = firebase.analytics();
            analytics.logEvent(SOT_CREATE_ACCOUNT, {});
            if (environment.skipVerification) {
              navigation.navigate('LetsBegin');
            } else {
              navigation.navigate('Verify');
            }
          }}
        />
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    backgroundColor: '#FFFFFF',
    width: globalStyles.container.width,
    margin: 'auto',
  },
  title: {
    fontFamily: 'Ubuntu',
    fontWeight: '500',
    fontSize: globalStyles.container.height < 800 ? 34 : 38,
    color: '#212529',
    marginBottom: 10,
    marginTop: globalStyles.container.height < 800 ? 10 : 20,
  },
  subTitle: {
    fontFamily: 'Jost Regular',
    fontSize: globalStyles.container.height < 800 ? 18 : 20,
    color: '#6C7570',
  },
  separatorClear: {
    marginVertical: 15,
    height: 1,
    width: '80%',
    margin: 'auto',
  },
  separator: {
    marginTop: 20,
    margin: 'auto',
    height: 1,
    backgroundColor: '#DEE2E6',
    // width: '100%',
    marginHorizontal: 10,
  },
  miniSection: {
    flex: 1,
    flexDirection: 'row',
    paddingHorizontal: 5,
    paddingTop: 30,
  },
  miniSectionLeft: {
    paddingTop: 3,
    marginRight: 10,
    // backgroundColor: '#eee',
  },
  miniSectionRight: {
    flex: 1,
  },
  miniSectionTitle: {
    paddingLeft: 10,
    fontFamily: 'Ubuntu',
    fontSize: globalStyles.container.height < 800 ? 20 : 22,
    fontWeight: '600',
    color: '#093F76',
  },
  miniSectionText: {
    paddingLeft: 10,
    color: '#212529',
    fontSize: globalStyles.container.height < 800 ? 18 : 20,
    fontFamily: 'Jost Regular',
    flex: 1,
  },
});
